import { render } from "./PickupRequests.vue?vue&type=template&id=1c2cd00c&ts=true"
import script from "./PickupRequests.vue?vue&type=script&lang=ts"
export * from "./PickupRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__